//import React from 'react';
import { connect } from 'react-redux';
import ItemEditView from '../components/ItemEditView'
import { currentUser } from '../../reducer';
import { getItemIds, getItemsById, getDraftItem } from '../../reducer';
import { syncItemProps } from '../actions'


const mapStateToProps = (state, { match }) => {

  const items_by_id = getItemsById(state)
  const item_id = match.params.id;
  const item = items_by_id.get(item_id)

  let account_subdomain = '';
  const account = currentUser(state).get("account");
  if (account !== undefined){
    account_subdomain = account.subdomain;
  }

  return {
    current_user_id: currentUser(state).get("id"),
    current_user: currentUser(state),
    item_ids: getItemIds(state),
    items_by_id: getItemsById(state),
    initialValues: {
      name: item.get("name"),
      description: item.get("description"),
      internal_notes: item.get("internal_notes")
    },
    apiVars: {
      venue_permalink: getDraftItem(state).get("venue_permalink"),
      item_id: item_id,
      api_token: currentUser(state).get("api_token"),
      account_subdomain: account_subdomain
    }
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {

    handleClearNameClick: () => {
      dispatch({
        type: "@@redux-form/CHANGE",
        meta: {
          form: "snap-photo",
          field: "name",
          touch: false,
          persistentSubmitErrors: false,
        },
        payload: ""
      });
    },
    onSubmit: ({name,description,internal_notes},{api_token,account_subdomain,item_id,venue_permalink}) => {

      dispatch(syncItemProps(api_token,venue_permalink,account_subdomain,item_id,{name,description,internal_notes}))

    },
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    onSubmit: (formData) => dispatchProps.onSubmit(formData,stateProps.apiVars)
  })
}


export const ItemEdit = connect(mapStateToProps,mapDipatchToProps,mergeProps)(ItemEditView);

export default ItemEdit;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/ItemEdit.js